import { Box, Center, Spinner, Grid } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import SidebarMenu from 'src/components/menu/sidebar/SidebarMenu';
import TopBar from 'src/components/top-bar/TopBar';
import colors from 'src/theme/colors';

export function FallbackAuth() {
  return (
    <Grid gridTemplateColumns="min-content auto">
      <SidebarMenu />
    </Grid>
  );
}

export function FallbackUnauth() {
  return (
    <>
      <Helmet>
        <style>{`body { background-color: ${colors.podcastShade100}; }`}</style>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <TopBar>
        <Box />
      </TopBar>
      <Center h="50%">
        <Spinner size="xl" color="podcastShade300" />
      </Center>
    </>
  );
}
